import React, { CSSProperties, ReactNode } from "react";
import Modal, { ModalProps } from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import { MdClose } from "react-icons/md";
import { purple } from "../config";
import { styled } from "@mui/material/styles";
import StyledButton from "./StyledButton";
import { Typography } from "@mui/material";

interface TransitionsModalProps {
  title?: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactNode;
  style: CSSProperties;
}

const StyledModal = styled(Modal)<ModalProps>(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: purple[500],
}));

const TransitionsModal = ({
  open,
  setOpen,
  title = "title",
  children,
  style,
}: TransitionsModalProps) => {
  return (
    <StyledModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={() => setOpen(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div
          style={{
            position: "relative",
            zIndex: 1,
            background: "white",
            outline: "none",
            borderRadius: 4,
            width: "90%",
            padding: 12,
            margin: 12,
            maxHeight: "90vh",
            overflow: "scroll",
            ...style,
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item />
            <Grid item>
              <Typography variant="h5">{title}</Typography>
            </Grid>

            <Grid item>
              <StyledButton
                icon={<MdClose fontSize="1.4rem" style={{ marginRight: -6 }} />}
                size="small"
                style={{
                  margin: 0,
                  padding: "0 7px",
                  zIndex: 10,
                  right: 42,
                  top: 32,
                }}
                onClick={() => setOpen(false)}
              />
            </Grid>
          </Grid>
          {children}
        </div>
      </Fade>
    </StyledModal>
  );
};

export default TransitionsModal;
